module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"confirm":"확인"}}')
  delete Component.options._Ctor
}
